import React, { Component } from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';

// Validation schema
const validationSchema = Yup.object({
  name: Yup.string().required('Name is required'),
  description: Yup.string().required('Description is required'),
});

// Custom input component
const CustomInput = ({ field, form, ...props }) => {
  const hasError = form.touched[field.name] && form.errors[field.name];

  return (
    <div className={props.parentClass || 'form-group'}>
      <input
        {...field}
        {...props}
        className={`${props.className || 'form-control'} ${hasError ? 'error' : ''}`}
        disabled={props.disabled}
      />
      {hasError && (
        <div className="error-message" style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>
          {form.errors[field.name]}
        </div>
      )}
    </div>
  );
};

class CreateComposer extends Component {
  constructor(props) {
    super(props);
    this.formikRef = React.createRef();
  }

  componentDidMount() {
    // Set initial values on mount if in EDIT mode
    this.setInitialValuesIfEdit();
  }

  componentDidUpdate(prevProps) {
    // Reset form when mode changes or initialValues update
    if (
      (this.props.mode !== prevProps.mode) ||
      (this.props.mode === 'EDIT' &&
        JSON.stringify(this.props.initialValues) !== JSON.stringify(prevProps.initialValues))
    ) {
      this.setInitialValuesIfEdit();
    }
  }

  setInitialValuesIfEdit = () => {
    if (this.props.mode === 'EDIT' && this.props.initialValues && this.formikRef.current) {
      const newValues = {
        name: this.props.initialValues.name || '',
        description: this.props.initialValues.description || '',
      };

      // Force form reset with new values
      this.formikRef.current.resetForm({
        values: newValues
      });
    }
  };

  getInitialValues = () => {
    if (this.props.mode === 'EDIT' && this.props.initialValues) {
      return {
        name: this.props.initialValues.name || '',
        description: this.props.initialValues.description || '',
      };
    }
    return {
      name: '',
      description: '',
    };
  };

  handleSubmit = (values, { setSubmitting }) => {
    if (this.props.mode === 'EDIT') {
      this.props.onEdit(values);
    } else {
      this.props.onCreate(values);
    }
    setSubmitting(false);
  };

  render() {
    const { mode, isCreating, isLoading, accessMode } = this.props;
    const isViewMode = accessMode === 'view';
    const isEditMode = accessMode === 'edit';

    // Create unique key for force remount
    const formKey = `${mode}-${this.props.initialValues?.name || 'new'}-${Date.now()}`;

    return (
      <section className="well create-piece">
        <Formik
          key={formKey} // Force remount when data changes
          ref={this.formikRef}
          initialValues={this.getInitialValues()}
          validationSchema={validationSchema}
          onSubmit={this.handleSubmit}
          enableReinitialize={true}
        >
          {({ isSubmitting, isValid, dirty, values }) => (
            <Form>
              <div className="row">
                <div className="col-md-3">
                  <label>Name</label>
                </div>
                <div className="col-md-9">
                  <Field
                    name="name"
                    type="text"
                    placeholder="Name"
                    component={CustomInput}
                    className={`form-control create-composer__name ${isViewMode ? 'disabled' : ''}`}
                    parentClass="form-group"
                    disabled={isViewMode}
                  />
                </div>

                <div className="col-md-3">
                  <label>Description</label>
                </div>
                <div className="col-md-9">
                  <Field
                    name="description"
                    type="text"
                    placeholder="Description"
                    component={CustomInput}
                    className={`form-control ${isViewMode ? 'disabled' : ''}`}
                    parentClass="form-group"
                    disabled={isViewMode}
                  />
                </div>

                {isEditMode && (
                  <div className="create-piece__btn-container">
                    <button
                      className="cus-btn-primary btn-block btn-lg"
                      type="submit"
                      disabled={isCreating || isSubmitting || (!dirty && mode === 'CREATE')}
                    >
                      {(isCreating || isSubmitting) ? (
                        <span className="spinner" />
                      ) : (
                        <span>{mode === 'EDIT' ? 'Update' : 'Create'}</span>
                      )}
                    </button>
                  </div>
                )}
              </div>
            </Form>
          )}
        </Formik>
      </section>
    );
  }
}

export default CreateComposer;
